module.exports = __webpack_public_path__ + "static/media/1005378.4713bfae.jpg";